import { EsgActionItem, SupplierEsgProfile } from '../../../../mocks/data/supplierEsgDashboardData';

/** Filters shared across every tab of the Supplier ESG Dashboard. */
export interface EsgDashboardFilters {
  supplierId: number | '';
  supplierGroup: string;
  category: string;
  contractRef: string;
  client: string;
  region: string;
  certification: string;
  minEsgScore: number | '';
  riskLevel: string;
  reviewedFrom: string;
  reviewedTo: string;
}

export const EMPTY_ESG_DASHBOARD_FILTERS: EsgDashboardFilters = {
  supplierId: '',
  supplierGroup: '',
  category: '',
  contractRef: '',
  client: '',
  region: '',
  certification: '',
  minEsgScore: '',
  riskLevel: '',
  reviewedFrom: '',
  reviewedTo: '',
};

export function filterEsgProfiles(profiles: SupplierEsgProfile[], filters: EsgDashboardFilters): SupplierEsgProfile[] {
  return profiles.filter((p) => {
    if (filters.supplierId && p.supplierId !== filters.supplierId) return false;
    if (filters.supplierGroup && p.supplierGroup !== filters.supplierGroup) return false;
    if (filters.category && p.category !== filters.category) return false;
    if (filters.contractRef && p.contractRef !== filters.contractRef) return false;
    if (filters.client && p.client !== filters.client) return false;
    if (filters.region && p.region !== filters.region) return false;
    if (filters.certification && !p.sustainabilityCertifications.includes(filters.certification) && !p.governanceCertifications.includes(filters.certification)) return false;
    if (filters.minEsgScore !== '' && p.esgScore < filters.minEsgScore) return false;
    if (filters.riskLevel && p.riskLevel !== filters.riskLevel) return false;
    if (filters.reviewedFrom && p.lastReviewed < filters.reviewedFrom) return false;
    if (filters.reviewedTo && p.lastReviewed > filters.reviewedTo) return false;
    return true;
  });
}

export type EsgDashboardTab = 'overview' | 'environmental' | 'social' | 'governance' | 'operational' | 'spend' | 'comparison' | 'risk';

export interface EsgActionItemsTableProps {
  title: string;
  items: EsgActionItem[];
}
